import { useLayoutEffect } from "react";

import { Spinner } from "@/components/spinner/Spinner";

export const LIVE_DOC_ATTRIBUTE = "data-live-doc";

const JS_CRAWLER_USER_AGENT =
  /Googlebot|Google-InspectionTool|bingbot|BingPreview|Applebot|YandexBot|DuckDuckBot|Baiduspider/i;

function willLoadEditor(): boolean {
  return "WebSocket" in window && !JS_CRAWLER_USER_AGENT.test(navigator.userAgent);
}

const LIVE_DOC_DETECTION_SCRIPT = `if ("WebSocket" in window && !${JS_CRAWLER_USER_AGENT}.test(navigator.userAgent)) document.documentElement.setAttribute("${LIVE_DOC_ATTRIBUTE}", "");`;

type Props = {
  /** The document rendered on the server, absent when the public may not read it. */
  ssrHtml?: string;
};

export function LoadingDocument({ ssrHtml }: Props) {
  useLayoutEffect(() => {
    if (ssrHtml && willLoadEditor()) {
      document.documentElement.setAttribute(LIVE_DOC_ATTRIBUTE, "");
    }
  }, [ssrHtml]);

  return (
    <>
      {ssrHtml && (
        <script
          id="live-doc-detection"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: LIVE_DOC_DETECTION_SCRIPT }}
        />
      )}
      <div className={ssrHtml ? "hidden [html[data-live-doc]_&]:contents" : "contents"}>
        <Spinner />
      </div>
      {ssrHtml && (
        <article
          data-ssr-document
          className="py-14 px-12 sm:px-6 sm:pt-7 sm:mt-20 [html[data-live-doc]_&]:hidden"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: ssrHtml }}
        />
      )}
    </>
  );
}
